module.exports = __webpack_public_path__ + "img/file-earmark-arrow-down.91c467d9.svg";